import { render, staticRenderFns } from "./Allocation.vue?vue&type=template&id=6c9c6466&scoped=true&lang=pug&"
import script from "./Allocation.vue?vue&type=script&lang=ts&"
export * from "./Allocation.vue?vue&type=script&lang=ts&"
import style0 from "./Allocation.vue?vue&type=style&index=0&id=6c9c6466&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c9c6466",
  null
  
)

export default component.exports